import { render, staticRenderFns } from "./AboutTres.vue?vue&type=template&id=eb5d5df6"
import script from "./AboutTres.vue?vue&type=script&lang=js"
export * from "./AboutTres.vue?vue&type=script&lang=js"
import style0 from "./AboutTres.vue?vue&type=style&index=0&id=eb5d5df6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports